import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { MyharrellsService } from '../myharrells.service';
import { TakeabalancedapproachComponent } from "../takeabalancedapproach/takeabalancedapproach.component";
import { CanonicalService } from '../canonical.service';

interface ProductCategory {
  Category: string;
  Checked: boolean;
}

interface ProductClass {
  Class: string;
  Checked: boolean;
}

interface ProductBrand {
  Brand: string;
  Checked: boolean;
}
interface ProductVendor {
  Vendor: string;
  Checked: boolean;
}

@Component({
  selector: 'app-products',
  standalone: true,
  templateUrl: './products.component.html',
  styleUrl: './products.component.css',
  imports: [CommonModule, FormsModule, TakeabalancedapproachComponent]
})

export class ProductsComponent {

  constructor(private title: Title, private meta: Meta, public myHarrellsService: MyharrellsService, public dotComService: Dotcom2024Service, public router: Router, public route: ActivatedRoute, private canonicalService: CanonicalService) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Products/";
  productPhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/ProductPhotos/";

  productRecordsInDisplayArray: number = 0;

  classExpanded: boolean = false;
  categoryExpanded: boolean = false;
  brandExpanded: boolean = false;
  vendorExpanded: boolean = false;

  showFilterObjects: boolean = false;

  productCategoriesFiltered: ProductCategory[] = [];
  productCategoriesMaster: ProductCategory[] = [];
  productClassesFiltered: ProductClass[] = [];
  productClassesMaster: ProductClass[] = [];
  productBrandsFiltered: ProductBrand[] = [];
  productBrandsMaster: ProductBrand[] = [];

  addressesForAddressModalNoAllAddresses: any[] = [];

  QtyByItemArrayMax: any[] = [];

  EOPMode: boolean = false;

  loadedAll: boolean = false;

  ngOnInit(): void {

    this.myHarrellsService.bootstrapViewPortSize = this.myHarrellsService.getViewport();

    this.title.setTitle("Discover Harrell`s fertilizers, pesticides, and speciality products for golf, lawn care, and agriculture.  Expert-backed solutions for healthier turf and plants.");
    this.meta.updateTag({ name: 'description', content: "Discover Harrell’s custom fertilizers, specialty liquids, and the nation’s largest selection of branded pesticides. Browse products and labels now!" });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'og:description', content: "Discover Harrell’s custom fertilizers, specialty liquids, and the nation’s largest selection of branded pesticides. Browse products and labels now!" });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - products" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - products" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s Products | Custom Fertilizers & Pesticides" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Discover Harrell’s custom fertilizers, specialty liquids, and the nation’s largest selection of branded pesticides. Browse products and labels now!" });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - products" });
    // this.meta.updateTag({ name: 'author', content: "author tag here - products" });
    // this.dotComService.createCanonicalURL();
    this.canonicalService.updateCanonicalURL(window.location.href);

    //query strings come in from other page calls to filter - same as using side checbox filters but not by the users action
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);

      let filter = urlParams.get('filter');
      this.dotComService.productFilter = filter ? filter : "";

      if (this.dotComService.productFilter != "") {
        //automatically scroll to the filter section of the page if there is a filter in the query string
        const anchor = document.getElementById('productsFilterAnchor');
        anchor.scrollIntoView();
      }
    }


    if (this.myHarrellsService.onlineOrderingInEffect && this.myHarrellsService.addressSelected == "" && sessionStorage.getItem('EOPMode') != 'true') {
      //ONLINE ORDERING IS IN EFFECT - the variable was set true when the myharrells logged in user clicked the Online Ordering or BH Ordering button on 
      //the myharrells page menu on the left side of the screen
      this.OpenAddressModal();
    }
    else if (this.myHarrellsService.onlineOrderingInEffect && this.myHarrellsService.addressSelected != "") {
      this.AddressSelected(); //this loads address variables
    }
    else {
      this.myHarrellsService.thisAddressDetails = this.myHarrellsService.addressesListMaster.filter(x => x.ShipToAddress == this.myHarrellsService.addressSelected)[0];
    }


    this.dotComService.products = [];

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('EOPMode') == 'true') {
      //bh eop mode
      this.EOPMode = true;
      this.dotComService.partnership = this.myHarrellsService.customerNmbrSelected;
      if (this.myHarrellsService.addressSelected != '') {
      }
      else {
        this.OpenAddressModal();
      }

    }
    else {
      //regular online ordering mode or just got here from the main products link and not from myharrells
      this.EOPMode = false;
      if ((this.myHarrellsService.onlineOrderingInEffect && this.myHarrellsService.addressSelected != '') || this.myHarrellsService.onlineOrderingInEffect == false) {
        //user must have selected the address from the dropdown in my harrells left menu - go ahead and get the products
        //or they are on the products page and not from myharrells
        this.GetProducts();
      }
    }

  }

  ReturnToMyHarrells() {
    this.myHarrellsService.onlineOrderingInEffect = false;
    sessionStorage.removeItem('onlineOrderingInEffect');
    sessionStorage.removeItem('EOPMode');

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/myharrells']);
    })
  }

  GetProducts(): void {
    this.dotComService.products = []
    this.dotComService.productsMasterList = []
    this.productCategoriesFiltered = [];
    this.productCategoriesMaster = [];
    this.productClassesFiltered = [];
    this.productClassesMaster = [];
    this.productBrandsFiltered = [];
    this.productBrandsMaster = [];

    this.dotComService.ShowSpinnerModal();
    var x = this.dotComService.GetProductDetailSearchResults().subscribe(products => {
      if (products.length == 0) {
        this.dotComService.HideSpinnerModal();
      }
      else {

        for (var i = 0; i < products.length; i++) {

          this.dotComService.productsMasterList.push({ ItemNmbr: products[i].ItemNmbr, WebName: products[i].WebName.replace('<p>', '').replace('</p>', ''), WebDescription: products[i].WebDescription, SellingPrice: products[i].SellingPrice.toFixed(2), Agency: products[i].Agency, Cost: products[i].Cost, ImageURL: this.productPhotosImagePaths + products[i].ItemNmbr + ".jpg", WebClass: products[i].WebClass, MetaTag: products[i].MetaTag, Vendor: products[i].Vendor, WebCategory: products[i].WebCategory, Class: products[i].Class });
          if (i < 12) {
            //only display 12 products at a time
            this.dotComService.products.push(this.dotComService.productsMasterList[i]);
            this.productRecordsInDisplayArray = i; //this.productRecordsInDisplayArray + 1;
          }

          //list of all productClasses 
          if (this.productClassesMaster.filter(x => x.Class == products[i].WebClass).length == 0) {
            if (products[i].WebClass != null) {
              this.productClassesMaster.push({ Class: products[i].WebClass, Checked: false });
            }
          }

          //list of all productCategories
          if (this.productCategoriesMaster.filter(x => x.Category == products[i].WebCategory).length == 0) {
            if (products[i].WebCategory != null) {
              this.productCategoriesMaster.push({ Category: products[i].WebCategory, Checked: false });
            }
          }

          //list of all vendors - is now mixed in with brands drodpown 
          // if (this.productVendorsMaster.filter(x => x.Vendor == products[i].Vendor.trim()).length == 0) {
          //   if (products[i].Vendor != null && products[i].Vendor.trim() != "") {
          //     this.productVendorsMaster.push({ Vendor: products[i].Vendor.trim(), Checked: false });
          //   }
          // }
          if (this.productBrandsMaster.filter(x => x.Brand == products[i].Vendor.trim()).length == 0) {
            if (products[i].Vendor != null && products[i].Vendor.trim() != "") {
              this.productBrandsMaster.push({ Brand: products[i].Vendor.trim(), Checked: false });
            }
          }

          //list of all brands
          if (this.productBrandsMaster.filter(x => x.Brand == products[i].MetaTag.trim()).length == 0) {
            if (products[i].MetaTag != null && products[i].MetaTag.trim() != "") {
              this.productBrandsMaster.push({ Brand: products[i].MetaTag.trim(), Checked: false });
            }
          }


          if (i == products.length - 1) {

            //check if the image exists in the images beng displayed
            this.CheckIfImagesExisting();

            this.dotComService.productsMasterList.sort((a, b) => (a.WebName > b.WebName) ? 1 : -1);

            this.productClassesFiltered = this.productClassesMaster;
            this.productClassesFiltered.sort((a, b) => (a.Class > b.Class) ? 1 : -1);

            this.productCategoriesFiltered = this.productCategoriesMaster;
            this.productCategoriesFiltered.sort((a, b) => (a.Category > b.Category) ? 1 : -1);

            // this.productVendorsFiltered = this.productVendorsMaster;
            // this.productVendorsFiltered.sort((a, b) => (a.Vendor > b.Vendor) ? 1 : -1);

            this.productBrandsFiltered = this.productBrandsMaster;
            this.productBrandsFiltered.sort((a, b) => (a.Brand > b.Brand) ? 1 : -1);

            this.dotComService.HideSpinnerModal();

            if (this.dotComService.productFilter != "") {
              //filter by the query string


              if (this.dotComService.productFilter.indexOf(",") > -1) {
                //multiple values in the filter 
                //check all check boxes of those being filtered on 
                this.dotComService.products = [];
                setTimeout(function () {
                  //give the ui time to draw the checkboxes
                  let filterValues = this.dotComService.productFilter.split(",");
                  for (var j = 0; j < filterValues.length; j++) {
                    let theId = filterValues[j].toString();
                    (document.getElementById(theId) as HTMLInputElement).checked = true;
                    let z = this.productCategoriesFiltered.filter(x => x.Category == theId)[0];
                    z.Checked = true;
                  }
                  //now do the filtering based on what is checked 
                  for (var k = 0; k < this.dotComService.productsMasterList.length; k++) {
                    this.loadedAll = true;
                    let element = this.dotComService.productsMasterList[k];

                    for (var m = 0; m < this.productCategoriesFiltered.length; m++) {
                      if (this.productCategoriesFiltered[m].Checked) {
                        //if any are checked filter the products to only those with the class selected
                        if (element.WebCategory == this.productCategoriesFiltered[m].Category) {
                          if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                            this.dotComService.products.push(element);
                          }
                        }
                      }
                    }

                    //if the need to filter by multiple brands in the query string
                    // for (var m = 0; m < this.productBrandsFiltered.length; m++) {
                    //   if (this.productBrandsFiltered[m].Checked) {
                    //     //if any are checked filter the products to only those with the brand selected
                    //     if (element.MetaTag == this.productBrandsFiltered[m].Brand) {
                    //       if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                    //         this.dotComService.products.push(element);
                    //       }
                    //     }
                    //   }
                    // }

                    //if the need to filter by multiple classes in the query string
                    // for (var m = 0; m < this.productClassesFiltered.length; m++) {
                    //   if (this.productClassesFiltered[m].Checked) {
                    //     //if any are checked filter the products to only those with the class selected
                    //     if (element.WebClass == this.productClassesFiltered[m].Class) {
                    //       if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                    //         this.dotComService.products.push(element);
                    //       }
                    //     }
                    //   }
                    // }

                  }
                }.bind(this), 1000);

              } else {
                //just one value in the filter 
                this.loadedAll = true;
                this.FilterByQueryString();
              }
            }
          }
        }
      }
    })
  }

  CheckIfImagesExisting() {
    for (var i = 0; i < this.dotComService.products.length; i++) {
      let element = this.dotComService.products[i];

      let photoToUse = "";
      //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
      this.dotComService.checkIfImageExists(this.productPhotosImagePaths + element.ItemNmbr + ".jpg", (exists) => {
        if (exists) {
          // Success code
          //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
          element.ImageURL = this.productPhotosImagePaths + element.ItemNmbr + ".jpg";
        } else {
          // Fail code
          this.dotComService.checkIfImageExists(this.productPhotosImagePaths + element.ItemNmbr + ".png", (exists) => {
            if (exists) {
              // Success code
              element.ImageURL = this.productPhotosImagePaths + element.ItemNmbr + ".png";
            } else {
              // Fail code - use default
              if (element.Class.toUpperCase() == "FERT-FIN") {
                element.ImageURL = this.pageImagePaths + "profertilizer_default.jpg";
              }
              else if (element.Class.toUpperCase() == "FERT-SP-FIN") {
                element.ImageURL = this.pageImagePaths + "profertilizer_sp_default.jpg";
              }
              else {
                element.ImageURL = this.pageImagePaths + "harrellsh.png";
              }
            }
          })
        }
      });
    }
  }

  FilterByQueryString() {
    //this is done from the sublinks on the normal part of the site (not myharrells)
    // if (this.dotComService.productFilter == 'Polyon') {
    if (this.productBrandsFiltered.filter(x => x.Brand == this.dotComService.productFilter).length > 0) {
      //filtering by a brand here
      this.brandExpanded = true;
      this.FilterProductsDisplay("Brand", { Brand: this.dotComService.productFilter, Checked: false }, null).then(() => {
        setTimeout(() => {
          //now check the checkbox 
          (document.getElementById(this.dotComService.productFilter) as HTMLInputElement).checked = true;
        }, 100);
      })
    }
    else if (this.productCategoriesFiltered.filter(x => x.Category == this.dotComService.productFilter).length > 0) {
      //filtering by a category here
      this.categoryExpanded = true;
      this.FilterProductsDisplay("Category", { Category: this.dotComService.productFilter, Checked: false }, null).then(() => {
        setTimeout(() => {
          //now check the checkbox 
          (document.getElementById(this.dotComService.productFilter) as HTMLInputElement).checked = true;
        }, 100);
      })
    }
    else if (this.productClassesFiltered.filter(x => x.Class == this.dotComService.productFilter).length > 0) {
      //filtering by a class here
      this.classExpanded = true;
      this.FilterProductsDisplay("Class", { Class: this.dotComService.productFilter, Checked: false }, null).then(() => {
        setTimeout(() => {
          //now check the checkbox 
          (document.getElementById(this.dotComService.productFilter) as HTMLInputElement).checked = true;
        }, 100);
      })
    }

  }

  FilterProductsDisplay(control: string, row: any, e: Event) {
    return new Promise((resolve, reject) => {

      for (var i = 0; i < this.productCategoriesFiltered.length; i++) {
        this.productCategoriesFiltered[i].Checked = false;
      }
      for (var i = 0; i < this.productClassesFiltered.length; i++) {
        this.productClassesFiltered[i].Checked = false;
      }
      for (var i = 0; i < this.productBrandsFiltered.length; i++) {
        this.productBrandsFiltered[i].Checked = false;
      }

      this.dotComService.products = [];


      this.loadedAll = true;
      //if checked set the Checked property to true in the array
      //if unchecked set the Checked property to false in the array
      if (control == "Brand") {
        let item = this.productBrandsFiltered.filter(x => x.Brand == row.Brand)[0];
        if (item != null) {
          item.Checked = !item.Checked;
        }
      }
      // else if (control == "Vendor") {
      //   let item = this.productVendorsFiltered.filter(x => x.Vendor == row.Vendor)[0];
      //   if (item != null) {
      //     item.Checked = !item.Checked;
      //   }
      // }
      else if (control == "Class") {
        let item = this.productClassesFiltered.filter(x => x.Class == row.Class)[0];
        if (item != null) {
          item.Checked = !item.Checked;
        }
      }
      else if (control == "Category") {
        let item = this.productCategoriesFiltered.filter(x => x.Category == row.Category)[0];
        if (item != null) {
          item.Checked = !item.Checked

        }
      }

      this.dotComService.products = [];

      if (this.productBrandsFiltered.filter(x => x.Checked == true).length == 0
        // && this.productVendorsFiltered.filter(x => x.Checked == true).length == 0
        && this.productClassesFiltered.filter(x => x.Checked == true).length == 0
        && this.productCategoriesFiltered.filter(x => x.Checked == true).length == 0) {
        //none checked so show all
        this.dotComService.products = this.dotComService.productsMasterList;
        this.CheckIfImagesExisting();
        resolve('');

      }
      else {
        //at least one checked so filter 
        for (var i = 0; i < this.dotComService.productsMasterList.length; i++) {
          let element = this.dotComService.productsMasterList[i];

          for (var j = 0; j < this.productBrandsFiltered.length; j++) {
            if (this.productBrandsFiltered[j].Checked) {
              //if any are checked filter the products to only those with the brand selected
              if (element.MetaTag == this.productBrandsFiltered[j].Brand) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
              if (element.Vendor == this.productBrandsFiltered[j].Brand) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
            }
          }

          // for (var j = 0; j < this.productVendorsFiltered.length; j++) {
          //   if (this.productVendorsFiltered[j].Checked) {
          //     //if any are checked filter the products to only those with the vendor selected
          //     if (element.Vendor == this.productVendorsFiltered[j].Vendor) {
          //       if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
          //         this.dotComService.products.push(element);
          //       }
          //     }
          //   }
          // }

          for (var j = 0; j < this.productClassesFiltered.length; j++) {
            if (this.productClassesFiltered[j].Checked) {
              //if any are checked filter the products to only those with the class selected
              if (element.WebClass == this.productClassesFiltered[j].Class) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
            }
          }

          for (var j = 0; j < this.productCategoriesFiltered.length; j++) {
            if (this.productCategoriesFiltered[j].Checked) {
              //if any are checked filter the products to only those with the class selected
              if (element.WebCategory == this.productCategoriesFiltered[j].Category) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
            }
          }

          if (i == this.dotComService.productsMasterList.length - 1) {
            for (var k = 0; k < this.dotComService.products.length; k++) {
              this.dotComService.products[k].ItemPosition = k;
            }
            resolve('');
          }

          if (i == this.dotComService.productsMasterList.length - 1) {
            for (var k = 0; k < this.dotComService.products.length; k++) {
              if (k == this.dotComService.products.length - 1) {
                this.CheckIfImagesExisting();
              }
            }
          }

        }
      }
    })
  }

  FilterProductsDisplayBACKUP(control: string, row: any, e: Event) {
    return new Promise((resolve, reject) => {
      this.loadedAll = true;
      //if checked set the Checked property to true in the array
      //if unchecked set the Checked property to false in the array
      if (control == "Brand") {
        let item = this.productBrandsFiltered.filter(x => x.Brand == row.Brand)[0];
        if (item != null) {
          item.Checked = !item.Checked;
        }
      }
      // else if (control == "Vendor") {
      //   let item = this.productVendorsFiltered.filter(x => x.Vendor == row.Vendor)[0];
      //   if (item != null) {
      //     item.Checked = !item.Checked;
      //   }
      // }
      else if (control == "Class") {
        let item = this.productClassesFiltered.filter(x => x.Class == row.Class)[0];
        if (item != null) {
          item.Checked = !item.Checked;
        }
      }
      else if (control == "Category") {
        let item = this.productCategoriesFiltered.filter(x => x.Category == row.Category)[0];
        if (item != null) {
          item.Checked = !item.Checked

        }
      }

      this.dotComService.products = [];

      if (this.productBrandsFiltered.filter(x => x.Checked == true).length == 0
        // && this.productVendorsFiltered.filter(x => x.Checked == true).length == 0
        && this.productClassesFiltered.filter(x => x.Checked == true).length == 0
        && this.productCategoriesFiltered.filter(x => x.Checked == true).length == 0) {
        //none checked so show all
        this.dotComService.products = this.dotComService.productsMasterList;
        resolve('');

      }
      else {
        //at least one checked so filter 
        for (var i = 0; i < this.dotComService.productsMasterList.length; i++) {
          let element = this.dotComService.productsMasterList[i];

          for (var j = 0; j < this.productBrandsFiltered.length; j++) {
            if (this.productBrandsFiltered[j].Checked) {
              //if any are checked filter the products to only those with the brand selected
              if (element.MetaTag == this.productBrandsFiltered[j].Brand) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
              if (element.Vendor == this.productBrandsFiltered[j].Brand) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
            }
          }

          // for (var j = 0; j < this.productVendorsFiltered.length; j++) {
          //   if (this.productVendorsFiltered[j].Checked) {
          //     //if any are checked filter the products to only those with the vendor selected
          //     if (element.Vendor == this.productVendorsFiltered[j].Vendor) {
          //       if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
          //         this.dotComService.products.push(element);
          //       }
          //     }
          //   }
          // }

          for (var j = 0; j < this.productClassesFiltered.length; j++) {
            if (this.productClassesFiltered[j].Checked) {
              //if any are checked filter the products to only those with the class selected
              if (element.WebClass == this.productClassesFiltered[j].Class) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
            }
          }

          for (var j = 0; j < this.productCategoriesFiltered.length; j++) {
            if (this.productCategoriesFiltered[j].Checked) {
              //if any are checked filter the products to only those with the class selected
              if (element.WebCategory == this.productCategoriesFiltered[j].Category) {
                if (this.dotComService.products.filter(x => x.ItemNmbr == element.ItemNmbr).length == 0) {
                  this.dotComService.products.push(element);
                }
              }
            }
          }

          if (i == this.dotComService.productsMasterList.length - 1) {
            resolve('');
          }

        }
      }
    })
  }

  GetEOPProductSearchResults(): void {
    this.dotComService.products = []
    this.dotComService.productsMasterList = []
    this.dotComService.displayWarning = false;
    this.dotComService.warningText = "";

    this.productCategoriesFiltered = [];
    this.productCategoriesMaster = [];
    this.productClassesFiltered = [];
    this.productClassesMaster = [];
    this.productBrandsFiltered = [];
    this.productBrandsMaster = [];
    // this.productVendorsFiltered = [];
    // this.productVendorsMaster = [];

    this.dotComService.ShowSpinnerModal();
    var x = this.dotComService.GetEOPProductSearchResults().subscribe(products => {
      if (products.length == 0) {
        this.dotComService.displayWarning = true;
        this.dotComService.warningText = "There are no Bill & Hold Items available for this customer to order online at this time.";
        //hide the message automatically
        // setTimeout(function () {
        //   this.dotComService.displayWarning = false;
        //   this.dotComService.warningText = "";
        // }.bind(this), 2000);
        // //go back to myharrells page
        this.router.navigate(['/myharrells']);
         this.dotComService.HideSpinnerModal();

      }
      else {
        if (this.myHarrellsService.addressSelected == "") {
          this.OpenAddressModal();
        }

        //show the items that came back 
        this.QtyByItemArrayMax = [];

        for (var i = 0; i < products.length; i++) {
          let itemNumToForwardTo = (products[i].MasterItemNmbr == null || products[i].MasterItemNmbr == "") ? products[i].ItemNmbr.replace("ZZ", "") : products[i].MasterItemNmbr;
          this.QtyByItemArrayMax.push({ ItemNmbr: itemNumToForwardTo, QtyTotal: products[i].EQUOMQTY });
          // alert('check the below when the item is in the cart')
          //check to see if any of the available have been depleded because they already existing in the order
          let ShoppingCart2 = JSON.parse(sessionStorage.getItem('ShoppingCart') || '{}')
          if (ShoppingCart2 != null) {
            for (var j = 0; j < ShoppingCart2.length; j++) {
              if (ShoppingCart2[j].itemNmbr == products[i].ItemNmbr.replace("ZZ", "")) {
                products[i].EQUOMQTY = products[i].EQUOMQTY - ShoppingCart2[j].qty
              }
            }
          }
          this.dotComService.productsMasterList.push({ ItemNmbr: itemNumToForwardTo, WebName: products[i].WebName, WebDescription: products[i].WebDescription, EQUOMQTY: products[i].EQUOMQTY, ImageURL: this.productPhotosImagePaths + itemNumToForwardTo + ".jpg", zzItemNmbr: products[i].ItemNmbr, WebClass: products[i].WebClass, MetaTag: products[i].MetaTag, Vendor: products[i].Vendor, WebCategory: products[i].WebCategory, Class: products[i].Class });

          //list of all productCategories
          if (this.productCategoriesMaster.filter(x => x.Category == products[i].WebCategory).length == 0) {
            if (products[i].WebCategory != null) {
              this.productCategoriesMaster.push({ Category: products[i].WebCategory, Checked: false });
            }
          }

          //list of all productClasses 
          if (this.productClassesMaster.filter(x => x.Class == products[i].WebClass).length == 0) {
            if (products[i].WebClass != null) {
              this.productClassesMaster.push({ Class: products[i].WebClass, Checked: false });
            }
          }

          //list of all brands 
          if (this.productBrandsMaster.filter(x => x.Brand == products[i].MetaTag).length == 0) {
            if (products[i].MetaTag != null && products[i].MetaTag != "") {
              this.productBrandsMaster.push({ Brand: products[i].MetaTag, Checked: false });
            }
          }

          // //list of all vendors 
          // if (this.productVendorsMaster.filter(x => x.Vendor == products[i].Vendor).length == 0) {
          //   if (products[i].Vendor != null && products[i].Vendor != "") {
          //     this.productVendorsMaster.push({ Vendor: products[i].Vendor, Checked: false });
          //   }
          // }

          if (i == products.length - 1) {
            this.dotComService.HideSpinnerModal();

            //sort this.dotComService.productsMasterList
            this.dotComService.productsMasterList.sort((a, b) => (a.WebName > b.WebName) ? 1 : -1);

            if (this.myHarrellsService.thisAddressDetails == undefined) {
              this.myHarrellsService.thisAddressDetails = [];
            }
            this.dotComService.products = this.dotComService.productsMasterList
            sessionStorage.setItem("QtyByItemMax", JSON.stringify(this.QtyByItemArrayMax)) //total avail to start
            sessionStorage.setItem("QtyByItem", JSON.stringify(this.QtyByItemArrayMax)) //running total after adjustmens

            this.productCategoriesFiltered = this.productCategoriesMaster;
            this.productClassesFiltered = this.productClassesMaster;
            this.productBrandsFiltered = this.productBrandsMaster;
            // this.productVendorsFiltered = this.productVendorsMaster;
            //sort the arrays
            this.productCategoriesFiltered.sort((a, b) => (a.Category > b.Category) ? 1 : -1);
            this.productClassesFiltered.sort((a, b) => (a.Class > b.Class) ? 1 : -1);
            this.productBrandsFiltered.sort((a, b) => (a.Brand > b.Brand) ? 1 : -1);
            // this.productVendorsFiltered.sort((a, b) => (a.Vendor > b.Vendor) ? 1 : -1);

             this.CheckIfImagesExisting();
          }
        }
      }
    })
  }

  LoadMoreProducts(): void {
    //load more button fired - get another 12 if they are 12 left in the productsMasterList array to get
    for (var i = 0; i < 12; i++) {
      if (this.dotComService.products.length < this.dotComService.productsMasterList.length) {
        this.productRecordsInDisplayArray = this.productRecordsInDisplayArray + 1;
        this.dotComService.products.push(this.dotComService.productsMasterList[this.productRecordsInDisplayArray]);
        if (i == 11) {
          this.CheckIfImagesExisting();

        }
      }
    }
  }

  FilterProductsFired(): void {
    this.GetProducts();
  }

  ViewAllProducts(): void {
    //clear all filter variables and recall to display all products
    this.dotComService.productSearch = "";
    //uncheck all brands
    for (var i = 0; i < this.productBrandsFiltered.length; i++) {
      this.productBrandsFiltered[i].Checked = false;
    }
    //uncheck all vendors
    // for (var i = 0; i < this.productVendorsFiltered.length; i++) {
    //   this.productVendorsFiltered[i].Checked = false;
    // }
    //uncheck all classes
    for (var i = 0; i < this.productClassesFiltered.length; i++) {
      this.productClassesFiltered[i].Checked = false;
    }
    //uncheck all categories
    for (var i = 0; i < this.productCategoriesFiltered.length; i++) {
      this.productCategoriesFiltered[i].Checked = false;
    }


    //this.GetProducts();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/products']);
    })
  }

  ViewProductsDetail(row: any): void {
    if (this.EOPMode) {
      sessionStorage.setItem('zzItemNmbr', row.zzItemNmbr);
    }
    else {
      sessionStorage.removeItem('zzItemNmbr');
    }

    this.router.navigate(['/product'],
      { queryParams: { sku: row.ItemNmbr } })
  }

  OpenAddressModal() {
    this.addressesForAddressModalNoAllAddresses = this.myHarrellsService.addressesListFiltered.filter(x => x.Address1 != 'All Addresses');
    this.addressesForAddressModalNoAllAddresses.unshift({ Address1: '--Select--', AddressId: '', SalesPersonId: '', Adrscode: '' }); 
    document.getElementById("addressModal").style.display = "block";
  }

  CloseAddressModal() {
    document.getElementById("addressModal").style.display = "none";
  }

  CancelOnlineOrderAtAddressPrompt() {
    //reset the variables that set the mode to online ordering
    this.myHarrellsService.onlineOrderingInEffect = false;
    sessionStorage.removeItem('onlineOrderingInEffect');
    this.CloseAddressModal();
    //go back to myharrells page
    this.router.navigate(['/myharrells']);
  }

  AddressSelected() {

    //this.myHarrellsService.addressSelected has the address selected in dropdown
    this.CloseAddressModal();
    this.myHarrellsService.GetSelectedAddressDetails();

    //requery the products the use can select from based on their partnership
    if (this.myHarrellsService.thisAddressDetails.Adrscode == undefined) {
      if (this.myHarrellsService.thisAddressDetails.AddressId != '') {
        this.myHarrellsService.thisAddressDetails.Adrscode = this.myHarrellsService.thisAddressDetails.AddressId;
      }
    }
    this.myHarrellsService.GetServiceLocationForPartnerAndAddress(this.myHarrellsService.customerNmbrSelected, this.myHarrellsService.thisAddressDetails.Adrscode).subscribe((data: any) => {
      if (data.length > 0) {
        this.myHarrellsService.serviceLocation = data[0].Name.trim();
      }
    })

    if (sessionStorage.getItem('EOPMode') == 'true') {
      this.dotComService.partnership = this.myHarrellsService.customerNmbrSelected; // + '~' + this.myHarrellsService.thisAddressDetails.SalesPersonId; //'181'; //this is the custnmbr ~ rep id from the address record   //this.myHarrellsService.addressSelected.RepId;
      this.GetEOPProductSearchResults();
    }
    else {
      this.dotComService.partnership = this.myHarrellsService.customerNmbrSelected + '~' + this.myHarrellsService.thisAddressDetails.SalesPersonId; //'181'; //this is the custnmbr ~ rep id from the address record   //this.myHarrellsService.addressSelected.RepId;
      this.GetProducts();
    }

    //get the shopping cart info if it exists - user could have left the cart and come back 
    //they need to see where they left off 
    sessionStorage.removeItem('ShoppingCart');
    this.dotComService.GetDraftDetails(sessionStorage.getItem('CustomerNumberSelected'), sessionStorage.getItem('PartnershipCustomerAddressCodeselected')).subscribe((response: any) => {
      if (response.length > 0) {
        if (sessionStorage.getItem('ShoppingCart') == null) {
          // sessionStorage.setItem('ShoppingCart', JSON.stringify(response[0].ShoppingCart));
          sessionStorage.setItem('ShoppingCart', response[0].ShoppingCart);
          let sc = JSON.parse(sessionStorage.getItem("ShoppingCart") || "[]");
          this.dotComService.cartCount = sc.length;
        }
      }
      else
        this.dotComService.cartCount = 0;
    })
  }

  ToggleExpand(groupToExpand: string) {
    if (groupToExpand == "Class") {
      this.classExpanded = !this.classExpanded;
      if (this.classExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked = reload the grid
        this.dotComService.products = this.dotComService.productsMasterList;
      }
    }
    else if (groupToExpand == "Category") {
      this.categoryExpanded = !this.categoryExpanded;
      if (this.categoryExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked = reload the grid
        this.dotComService.products = this.dotComService.productsMasterList;
      }
    }
    else if (groupToExpand == "Brand") {
      this.brandExpanded = !this.brandExpanded;
      if (this.brandExpanded == false) {
        //group just collapsed and the checkboxes were set to unchecked = reload the grid
        this.dotComService.products = this.dotComService.productsMasterList;
      }
    }
    //vendor is now combined in brand 
    // else if (groupToExpand == "Vendor") {
    //   this.vendorExpanded = !this.vendorExpanded;
    //   if (this.vendorExpanded == false) {
    //     //group just collapsed and the checkboxes were set to unchecked = reload the grid
    //     this.dotComService.products = this.dotComService.productsMasterList;
    //   }
    // }
  }

  ToggleFilter() {
    this.showFilterObjects = !this.showFilterObjects;
  }

  OpenhowItWorksModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("howItWorksModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('howItWorksVideo')).play();
  }

  ClosehowItWorksModal() {
    (<HTMLVideoElement>document.getElementById('howItWorksVideo')).pause();
    document.getElementById("howItWorksModal").style.display = "none";
  }

}
